import images from "./images";

const testimonials = [
  {
    id: 1,
    image: images.testimonial1,
    name: "Amy Smith",
    title: "Laundry Enthusiast",
    content:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Eum aspernatur quod quis aliquam sit excepturi totam amet minima dolore ut atque eligendi, ipsum iste earum at necessitatibus. Nihil, impedit at.",
  },
  {
    id: 2,
    image: images.testimonial2,
    name: "John Davis",
    title: "Dry Cleaning Aficionado",
    content:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Eum aspernatur quod quis aliquam sit excepturi totam amet minima dolore ut atque eligendi, ipsum iste earum at necessitatibus. Nihil, impedit at.",
  },
  {
    id: 3,
    image: images.testimonial3,
    name: "Mia Johnson",
    title: "Stain Removal Specialist",
    content:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Eum aspernatur quod quis aliquam sit excepturi totam amet minima dolore ut atque eligendi, ipsum iste earum at necessitatibus. Nihil, impedit at.",
  },
  {
    id: 4,
    image: images.testimonial4,
    name: "David White",
    title: "Fabric Alterations Expert",
    content:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Eum aspernatur quod quis aliquam sit excepturi totam amet minima dolore ut atque eligendi, ipsum iste earum at necessitatibus. Nihil, impedit at.",
  },
];

export default testimonials;